module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elijah Wald\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Elijah Waldis a writer and musician whose books include Escaping the Delta: Robert Johnson and the Invention of the Blues and "), _c('I', [_vm._v("How the Beatles Destroyed Rock ’n’ Roll: An Alternative History of American Popular Music")]), _vm._v(". A respected expert on the folk revival, he collaborated with Dave Van Ronk on "), _c('I', [_vm._v("The Mayor of MacDougal Street")]), _vm._v(", the inspiration for the Coen Brothers’ film "), _c('I', [_vm._v("Inside Llewyn Davis")]), _vm._v(". His awards include a 2002 Grammy, and he has taught blues history at UCLA and lectured widely on American, Mexican, and world music. He currently lives in Medford, Massachusetts.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TOmGEp/tc-custom/9780062018441.jpg?1731883558626",
      "alt": "This image is the cover for the book Escaping the Delta"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Escaping the Delta\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The life of blues legend Robert Johnson becomes the centerpiece for this innovative look at what many consider to be America's deepest and most influential music genre. Pivotal are the questions surrounding why Johnson was ignored by the core black audience of his time yet now celebrated as the greatest figure in blues history.")]), _c('p', [_vm._v("Trying to separate myth from reality, biographer Elijah Wald studies the blues from the inside -- not only examining recordings but also the recollections of the musicians themselves, the African-American press, as well as examining original research. What emerges is a new appreciation for the blues and the movement of its artists from the shadows of the 1930s Mississippi Delta to the mainstream venues frequented by today's loyal blues fans.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0